import React from 'react';
import { Controller } from 'react-hook-form';
import { Checkbox } from '@mui/material';

export type CheckboxCellProps = {
  control: any;
  name: string;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
};

const CheckboxCell: React.FC<CheckboxCellProps> = ({
  control,
  name,
  onChange = () => {},
  disabled = false,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange: fieldOnChange } }) => (
        <Checkbox
          disabled={disabled}
          size="small"
          checked={value}
          onChange={(e) => {
            const newValue = e.target.checked;
            fieldOnChange(newValue);
            onChange(newValue);
          }}
        />
      )}
    />
  );
};

export default CheckboxCell;
